<ng-container>
	<div class="d-flex w-100" (click)="itemClick($event)">
		<div *ngIf="root && (!item.itemRole || item.userRole >= item.itemRole)" class="layout-menuitem-root-text">{{ item.label }}</div>
		<fa-icon *ngIf="root && !displayChildren" class="ms-auto" [icon]='["far","chevron-right"]'></fa-icon>
		<fa-icon *ngIf="root && displayChildren" class="ms-auto" [icon]='["far","chevron-down"]'></fa-icon>
	</div>

	<a
		*ngIf="!item.routerLink || item.items && (!item.itemRole || item.userRole >= item.itemRole)"
		[attr.href]="item.url"
		(click)="itemClick($event)"
		(mouseenter)="onMouseEnter()"
		(keydown.enter)="itemClick($event)"
		[ngClass]="item.class"
		pRipple
		[attr.target]="item.target"
		[attr.tabindex]="0"
	>
		<i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
		<span class="layout-menuitem-text">{{ item.label }}</span>
		<i class="pi pi-fw pi-chevron-down layout-submenu-toggler" *ngIf="item.items"></i>
	</a>
	<div class="d-flex w-100" [ngClass]="{'flex-fill': searchResult}">
		<a
			*ngIf="item.routerLink && !item.items && (!item.itemRole || item.userRole >= item.itemRole) && !item.hidden"
			(click)="itemClick($event)"
			(mouseenter)="onMouseEnter()"
			[routerLink]="item.routerLink"
			routerLinkActive="active-route"
			[ngClass]="item.class"
			pRipple
			[routerLinkActiveOptions]="{ exact: true }"
			[attr.target]="item.target"
			[attr.tabindex]="0"
			class="w-100"
		>
			<div class="p-grid w-100">
				<div class="p-col-2">
					<fa-icon *ngIf="item.faIconPrefix && item.faIcon" [icon]="[item.faIconPrefix,item.faIcon]" class="me-2"></fa-icon>
				</div>
				<div class="p-col-8">
					<i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
					<span class="layout-menuitem-text">{{ item.label }}</span>
					<i class="pi pi-fw pi-chevron-down layout-submenu-toggler" *ngIf="item.items"></i>
				</div>
				<div class="p-col-2 menu-star">
					<div *ngIf="!searchResult">
						<fa-icon
							*ngIf="item.parentKey === '2077c251-3ecb-40f5-9051-a9a55be03032'"
							[icon]='["fas","star"]'
							class="menu-star-hide my-auto ms-auto"
							(click)="toggleUserFavorite(item.key)"
						></fa-icon>
						<fa-icon
							*ngIf="item.parentKey !== '2077c251-3ecb-40f5-9051-a9a55be03032'"
							[icon]='["fal","star"]'
							class="menu-star-hide my-auto ms-auto"
							(click)="toggleUserFavorite(item.key)"
						></fa-icon>
					</div>
				</div>
			</div>
		</a>
	</div>

	<ul
		*ngIf="item.items && (!item.itemRole || item.userRole >= item.itemRole) && displayChildren"
		role="menu"
		[@children]="
					app.isSlim()
						? root
							? app.isMobile()
								? 'visible'
								: slimClick
								? active
									? 'slimVisibleAnimated'
									: 'slimHiddenAnimated'
								: active
								? 'visible'
								: 'hidden'
							: active
							? 'visible'
							: 'hidden'
						: root
						? 'visible'
						: active
						? 'visibleAnimated'
						: 'hiddenAnimated'
				"
	>
		<ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
			<li
				*ngIf="(!item.itemRole || item.userRole >= item.itemRole) && !item.hide"
				app-menuitem
				[item]="child"
				[index]="i"
				[parentKey]="key"
				[class]="child.badgeClass"
				[userRole]="child.userRole"
				[itemRole]="child.itemRole"
				[faIconPrefix]="child.faIconPrefix"
				[faIcon]="child.faIcon"
			></li>
		</ng-template>
	</ul>
</ng-container>
